import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { BuilderCallReasons } from 'shared/components/BuilderCallReasons';
import { selectBuilderCallReasonsExperimentActive } from 'shared/selectors/abExperiments';
import { getIsFromLeadFactory, getOfferPhones } from 'shared/selectors/newObject';
import { IPhoneSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { BuilderCallReasonsContactButtonContainer } from './parts/BuilderCallReasonsContactButtonContainer';
import { trackBuilderCallReasonsShowing } from './tracking';

export const BuilderCallReasonsContainer: React.VFC = () => {
  const isExperimentActive = useSelector(selectBuilderCallReasonsExperimentActive);
  const isFromLeadFactory = useSelector(getIsFromLeadFactory);

  const phones = useSelector(getOfferPhones);
  const filteredPhones = phones.filter((phone: IPhoneSchema) => !!phone.number);

  if (isExperimentActive && !isFromLeadFactory && filteredPhones[0]) {
    return (
      <ActionAfterViewObserver callback={trackBuilderCallReasonsShowing} triggerOnce callbackDelay={1000}>
        <BuilderCallReasons contactsButton={<BuilderCallReasonsContactButtonContainer />} />
      </ActionAfterViewObserver>
    );
  }

  return null;
};

// export default нужен для @loadable/component
// eslint-disable-next-line import/no-default-export
export default BuilderCallReasonsContainer;
